<section class="col-xs-12 col-md-12 mt-5" id="errororder" style="display: block;" *ngIf="enablePage.showSorryPage">
    <div class="thankorder_box">
        <div class="thankorder_text" [innerHtml]="data.content"></div>
        <a class="showPopupclick" (click)="handleOnOrdersClick()">
            <div class="viewbutton">View Orders</div>
        </a>
    </div>
</section>